const SCROLLABLE_OVERFLOW = new Set(["auto", "scroll", "overlay"]);

/**
 * true se `target` (ou um ancestral até `boundary`, inclusive) é um elemento
 * rolável verticalmente que de fato tem o que rolar.
 *
 * Usado para conter o scroll por toque dentro de sheets no iOS: se o toque não
 * cair numa área rolável, o handler de `touchmove` faz `preventDefault` e evita
 * que o documento/visual viewport "paneie" por fora do conteúdo.
 */
export function hasScrollableAncestor(
  target: EventTarget | null,
  boundary: Element | null,
): boolean {
  if (!(target instanceof Element) || typeof window === "undefined") {
    return false;
  }
  let el: Element | null = target;
  while (el) {
    const { overflowX, overflowY } = window.getComputedStyle(el);
    const canScrollY =
      SCROLLABLE_OVERFLOW.has(overflowY) &&
      el.scrollHeight > el.clientHeight + 1;
    const canScrollX =
      SCROLLABLE_OVERFLOW.has(overflowX) && el.scrollWidth > el.clientWidth + 1;
    if (canScrollY || canScrollX) {
      return true;
    }
    if (el === boundary) {
      break;
    }
    el = el.parentElement;
  }
  return false;
}
